<template>
  <div class="fill-height">


    <v-card class="fill-height">
      <v-card-title  class="p-1">
        <v-chip
            label    small
            class="ma-2"
            color="secondary">
        گزارش پرداخت شارژ پیامک
        </v-chip>
        <v-spacer/>
        <v-btn light icon @click="$router.push('/home')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>


      <v-card-text>
        <v-spacer/>
        <v-row>
          <v-col
              cols="12"
              md="4">

            <v-autocomplete
                :items="buildingList"
                v-model="params.buildingIds"
                @input="handleInput"
                dense
                multiple
                outlined
                :error-messages="getError('buildingIds')"
                auto-select-first  append-icon="fas fa-angle-down"
                label="انتخاب مجتمع"

            >
              <template v-slot:prepend-item>
                <v-checkbox
                    v-model="selectAll"
                    label="انتخاب همه "
                    @click="select_All_Building()"
                />
              </template>


              <template v-slot:selection="{ item, index }">
                <!--                    <v-chip v-if="index === 0">-->
                <span v-if="index === 0" >{{ item.text }}</span>
                <!--                    </v-chip>-->
                <span
                    v-if="index === 1"
                    class="grey--text caption"
                >
          (+{{ params.buildingIds.length - 1 }} دیگر)
        </span>
              </template>
            </v-autocomplete>

          </v-col>

          <v-col
              cols="12"

              md="3">

            <v-autocomplete
                :items="paymentStatusItem"
                v-model="params.status"
                @input="handleInput"
                dense
                outlined
                :error-messages="getError('status')"
                auto-select-first  append-icon="fas fa-angle-down"
                label="وضعیت پرداخت"

            />

          </v-col>

          <v-col
              cols="12"

              md="2">
            <date-picker placeholder="از تاریخ" v-model="params.dateFrom" color="#3b5694" clearable
                         auto-submit>
            </date-picker>
            <span style="color: red" v-if="getError('dateFrom')" v-text="getError('dateFrom')"/>
          </v-col>

           <v-col
              cols="12"

              md="2">
            <date-picker placeholder="تا تاریخ" v-model="params.dateTo" color="#3b5694" clearable
                         auto-submit>
            </date-picker>
            <span style="color: red" v-if="getError('dateTo')" v-text="getError('dateTo')"/>
          </v-col>
          <v-col
              cols="12"
              md="1"  >
            <v-btn small fab color="primary" @click="search"><v-icon>mdi-cloud-search</v-icon></v-btn>
          </v-col>
        </v-row>


        <v-spacer/>
      </v-card-text>
      <v-card-text>
        <b-table
            :items="dataItems"
            :fields="columns"
            show-empty
            sticky-header="450px"
            id="style-1"
            striped>

        </b-table>

      </v-card-text>
    </v-card>

  </div>
</template>

<script>
import Reporting from "./Service";
import {mapMutations} from "vuex";

export default {

  name: 'Manager',

  data() {
    return {
      params:{},
      data: {},
      buildingList: [],
      dataItems: [],
      paymentStatusItem: [],
      bindingErrors: [],
      selectAll:false,
      columns: [
        {key: 'building.name', label: 'نام مجتمع ', },
        {key: 'fullName', label: 'نام شخص', },
        {key: 'userName', label: 'نام کاربری', },
        {key: 'amount', label: 'مبلغ(ریال)', },
        {key: 'typeChargeText', label: 'نوع شارژ', },
        {key: 'bankPort', label: 'درگاه پرداختی', },
        {key: 'paymentDateText', label: 'تاریخ پرداخت', },
        {key: 'description', label: 'توضیحات', },

      ],

    };

  },

  methods: {
    ...mapMutations({
      setDrawer: 'SET_DRAWER',
      setMini: 'SET_MINI',
    }),
    handleInput (value) {
      this.$emit('input', value)
    },

    getError(key) {
      if (this.bindingErrors && this.bindingErrors.length > 0) {
        let error = this.bindingErrors.find( ({ fieldName }) => fieldName === key );
        if(error && error.message ) return  error.message[0]
      }
      return ''
    },

    fillDataItems() {
      Reporting.getPage().then(response => {
        this.buildingList = response.data.buildingList
        this.params = response.data.params
        this.paymentStatusItem = response.data.paymentStatusItem
      });
    },
    select_All_Building(){
      this.params.buildingIds = [];
      if (this.selectAll) {
        for (let item in this.buildingList) {
          this.params.buildingIds.push(this.buildingList[item].value);
        }
      }
    },
    search() {
      this.dataItems=[]
      this.bindingErrors=[]
      this.$progress({message: 'درحال جستجو...'}, true)
       Reporting.search(this.params).then(response => {
        if (response && response.status === 200) {
          this.$root.$emit('Progress')
          this.dataItems = response.data
        }else if (response && response.response.status === 400) {
          this.$root.$emit('Progress')
          this.bindingErrors = response.response.data;
        }
      })
    },

  },



created() {
    this.fillDataItems()
  this.setDrawer(false)
}

}
</script>

<style>
.table th, .table td {
  padding: 5px !important;
}

</style>
